<template >
  <div>
    <div class="selectType">
      <el-row>
        <el-col :span="2" class="taskType">
          <span>分类:</span>
        </el-col>
        <el-col :span="6">
          <el-select v-model="selectType" clearable placeholder="请选择" class="select" size='mini' @change="changeList">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2" class="taskType">
          <span>选择日期:</span>
        </el-col>
        <el-col :span='6'>
          <el-date-picker v-model="selectDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size='mini'></el-date-picker>
        </el-col>
      </el-row>
      <el-row>
        <div class="taskType key">
          <el-row>
            <el-col :xs="5" :sm="4" :md="3" :lg="2" :xl="2" class="searchKey">关键字:</el-col>
            <el-col :xs="19" :sm="20" :md="21" :lg="22" :xl="22">
              <el-input class="searchBox" v-model="keys" placeholder="请输入关键字" style="width:30%" size='mini'></el-input>
              <el-button type="primary" style="height: 27px" class="searchBtn" @click="searchData" size='mini'><span style="font-size:13px">搜索</span></el-button>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </div>
    <!-- 发送通知 -->
    <div class="send">
      <span @click="goAddMessage"><i class="el-icon-circle-plus-outline"></i><span>发送通知</span></span>
    </div>
    <div class="nav" v-loading='loading'>
      <div  style="cursor: pointer" v-show="totalCount > 0" class="noticeNav" v-for="(item,index) in noticeList" :key="index" @click="goDetail(item.id, item.status)">
        <el-row>
          <el-col :span='24'>
            <div class="taskTitle">
              <el-row>
                <el-col :span='16'>
                  <div class="tit">项目名称: {{ projectName }}</div>
                  <div class="icon icon1" v-show="item.type == 2">个人</div>
                  <div class="icon icon2" v-show="item.type == 1">实验</div>
                </el-col>
                <el-col :span='8'><div class="taskTime">{{ item.createTime }}</div></el-col>
              </el-row>
            </div>
            <div v-if="item.type == 2" class="receiver">
                <span>接受者：{{ item.receiverName }}</span>
            </div>
            <el-row style="over-flow:hidden;">
              <el-col :span='24'>
                <div class="text" >
                  {{ item.messageContent }}
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div class="pagination" v-if="totalCount > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
      <div v-else style="margin: 100px 0; width: 100%; text-align:center;font-size:16px;">
        暂无数据!
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      projectName: '',
      userId: null,
      options: [{value: 1, label: '实验通知'}, {value: 2, label: '个人通知'}],
      selectDate: '', // 选择时间
      keys: '', // 关键字
      noticeList: [],
      selectType: '',  // 选择类型
      totalCount: 0,
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页数据量
      projectId: '',
    }
  },

  created () {
    if (this.$route.query.id) {
      this.projectId = +this.$route.query.id
    } else {
      this.projectId = +this.$store.state.projectId
    }
    let userInfo = this.$cookies.get('userInfo')
    this.userId = userInfo.worketId
    this.projectName = this.$store.state.projectName
    this.getMessage()
  },

  methods: {

    // 初始化 获取消息列表
    getMessage() {
      this.loading= true
      var param = {
        projectId: this.projectId,
        createTime: null,
        keyword: null,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      };
      this.httpPost("/web/message/v1/searchMessageListByType", param).then(res => {
        if (res.code == 0) {
          this.noticeList = res.data.data;
          this.totalCount = res.data.total;
          this.loading= false
        } else if (res.code == 10001 || res.code == 10002) {
          this.loading= false
          this.$message({
            type: 'error',
            message: res.message
          })
        } else {
          this.loading= false
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      });
    },

    // 搜索消息
    searchData() {
      this.loading= true
      var param = {
        projectId: this.projectId,
        type: this.selectType,
        createTime: this.selectDate,
        keyword: this.keys,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      };
      this.httpPost("/web/message/v1/searchMessageListByType", param).then(res => {
        if (res.code == 0) {
          this.noticeList = res.data.data;
          this.totalCount = res.data.total;
          this.loading= false
        } else if (res.code == 10001 || res.code == 10002) {
          this.loading= false
          this.$message({
            type: 'error',
            message: res.message
          })
        } else {
          this.loading= false
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      });
    },

    // 切换消息类型
    changeList (val) {
      this.searchData()
    },

    // 添加消息
    goAddMessage () {
     this.$router.push({
        path: '/messageAdd',
        query: {
          id: this.projectId,
          name: this.projectName
        }
      })
    },

    // 前往详情页
    goDetail (id, status) {
      this.$router.push({
        path: '/messageDetail',
        query: {
          id: id,
          name: this.projectName
        }
      })
    },

    // 改变当前每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchData();
    },
    // 改变当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchData();
    },

  }
}
</script>

<style lang="scss" scoped>
  .icon{
    display: inline-block;
    width: 43px;
    text-align: center;
    height: 17px;
    color: #fff;
    line-height: 16px !important;
    border-radius: 5px;
    font-size: 13px !important;
    font-weight: 300 !important;
  }
  .receiver{
    span{
      display: inline-block;
      margin-bottom: 10px;
      font-weight: 600;
      color: #444;
      font-size: 13px;
      margin-left: 18px;
    }
  }
  .icon1{
    background-color: #8bc34a;
  }
  .icon2{
    background-color: #ff9800;
  }
  .selectType{
    margin: 20px 0px 0;
    .taskType{
      font-weight: bold;
      padding: 5px 0px 10px;
      font-size: 15px;
      cursor: pointer;
      .searchKey{
        margin-top: 5px;
      }
    }
    .key{
      margin-top: 5px;
    }
  }
  .nav{
    margin-bottom: 50px;
  }
  .send{
    margin: 20px 0 10px;
    i{
      cursor: pointer;
      color: #3c82a8;
      padding-right: 10px;
      font-size: 18px;
      font-weight: bold;
      vertical-align: text-bottom;
    }
    span{
      cursor: pointer;
      color: #3c82a8;
    }
  }
  .noticeNav{
    padding: 30px 0px;
    border-bottom: 1px solid #dfdfdf;
    .tip{
      text-align: right;
      padding-right: 20px;
      img{
        width: 8px;
      }
    }
    .text{
      white-space:nowrap;
      text-overflow:ellipsis;
      letter-spacing:.5px;
      height: 20px;
      overflow: hidden;
      font-size: 14px;
      line-height: 20px;
    }
    .replyText{
      margin-top: 10px;
      padding-top: 10px;
      border-top: 1px solid #dfdfdf;
    }
    .deleteBtn{
      float: right;
      margin-top: 5px;
      text-align: right;
      color: #ff4a4a;
      cursor: pointer;
    }
    .lettertn{
      float: right;
    }
    .tipBox{
      width: 100%;
      margin: 20px auto 0px;
      textarea{
        display: inline-block;
        width: 100%;
      }
      .reply{
        width: 100%;
        text-align: right;
        span{
          display: inline-block;
          margin: 20px 0 0;
          cursor: pointer;
          color: #ff4a4a;
        }
      }
    }
  }
  .taskTitle{
    margin-bottom: 10px;
    .tit{
      display: inline-block;
      font-weight: bold;
      font-size: 14px;
      margin-right: 8px;
      vertical-align: middle;
    }
    .taskTime{
      width: 100%;
      font-size: 12px;
      text-align: right;
      color: #999999;
    }
  }
  .pagination{
    margin-top: 30px;
    float: right;
    margin-bottom: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/components/data/message.vue